import { AgentWidgetConfig } from "../../apis/agent.api";
import { Phone } from "lucide-react";
import { FC } from "react";
import { Button } from "../../components/ui/button";
import AgentAvatar from "./agent-avatar";

interface IncomingCallProps {
  handleAnswer: () => void;
  config: AgentWidgetConfig;
}

const IncomingCall: FC<IncomingCallProps> = ({ handleAnswer, config }) => {
  return (
    <div
      onClick={handleAnswer}
      className="bg-white duration-300 cursor-pointer flex items-center rounded-[16px] shadow-widget justify-between relative gap-5 text-black w-[280px]"
    >
      <div className="bg-green-500 rounded-full size-[10px] absolute top-2 right-2" />
      <div className="flex items-center gap-3">
        <AgentAvatar className="size-[60px] rounded-none rounded-l-[16px]" config={config} />
        <div className="text-black text-start">
          <h3 className="text-[16px]">{config?.ai_agent.agent_name} is online</h3>
          <p className="font-medium text-sm opacity-50">
           click to chat or call
          </p>
        </div>
      </div>

      <Button
        className="rounded-full bg-[rgba(255,255,255,0.14)] border-none text-white size-[37px]"
        variant="outline"
        size="icon"
        onClick={handleAnswer}
      >
        <Phone />
      </Button>
    </div>
  );
};

export default IncomingCall;
